// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectQuoteMessage } from './DirectQuoteMessage';
import { HistoryType } from '../../Utils/History/HistoryType';
import { DirectQuote3Message } from './DirectQuote3Message';
import { Message } from './Message';
import { DirectQuote1Message } from './DirectQuote1Message';
export class DirectInstrumentDayBarMessage extends DirectQuoteMessage {
    constructor() {
        super(Message.CODE_INSTRUMENT_DAY_BAR);
        this.Type = HistoryType.QUOTE_INSTRUMENT_DAY_BAR;
        this.Open = null;
        this.High = null;
        this.Low = null;
        // ахтунг! на сервере сказали,
        // что этот филд используется только в старой схеме,
        // когда приходит только один InstrumentDayBarMessage
        this.TodayClosePrice = null;
        this.PreviousClosePrice = null;
        this.Ticks = null;
        this.Volume = null;
        this.OpenInterest = null;
        this.SettlementPrice = null;
        this.PrevSettlementPrice = null;
        this.LastPrice = null;
        this.LastSize = null;
        this.LastVenue = null;
        this.LastTime = null;
        this.AskOpen = null;
        this.AskHigh = null;
        this.AskLow = null;
        this.AskTodayClosePrice = null;
        this.AskPreviousClosePrice = null;
        this.FiftyTwoWeekHighPrice = null;
        this.FiftyTwoWeekLowPrice = null;
        this.High13Week = null;
        this.Low13Week = null;
        this.High26Week = null;
        this.Low26Week = null;
        this.Delay = null;
        // Иногда значение Change,
        // которое приходит с вендора не совпадает с расчетным на клиенте,
        // в этом случае здаем сhange в это поле
        this.Change = null;
        // см. Change
        this.ChangeInPercent = null;
        // #46480, #46585 - для какого инструмента пришел мессадж
        this.InstrumentBarType = null;
        // #71250
        this.ReferencePrice = null;
        this.InstrumentTradableID = null;
        this.TradableId = undefined;
        this.QuoteRouteId = undefined;
        this.Time = undefined; // TODO можна видалити цей рядок
        this.TargetInstrumentName = undefined;
    }
    GenerateQuoteMessage(historyType) {
        if (this.InstrumentBarType && this.InstrumentBarType != historyType) {
            return null;
        }
        if (historyType == HistoryType.QUOTE_TRADES) {
            return this.GenerateQuote3Message();
        }
        else {
            return this.GenerateQuote1Message(historyType);
        }
    }
    GenerateQuote1Message(historyType) {
        if (this.TodayClosePrice === null || !this.LastTime) // нельзя сгенерировать
         {
            return null;
        }
        const q1m = new DirectQuote1Message();
        this.CopyQuoteMsg(q1m);
        q1m.Code = Message.CODE_QUOTE;
        q1m.Type = historyType;
        q1m.Ask = this.TodayClosePrice;
        q1m.Bid = this.TodayClosePrice;
        q1m.TotalVolume = this.Volume;
        q1m.Time = this.LastTime;
        return q1m;
    }
    GenerateQuote3Message() {
        if (!this.LastPrice || !this.Volume || !this.LastTime) // нельзя сгенерировать
         {
            return null;
        }
        const q3m = new DirectQuote3Message();
        this.CopyQuoteMsg(q3m);
        q3m.Code = Message.CODE_QUOTE3;
        q3m.Type = HistoryType.QUOTE_TRADES;
        q3m.Price = this.LastPrice;
        q3m.Size = this.Volume;
        q3m.Time = this.LastTime;
        // hsa: остальные филды мне в BaseInterval не нужны
        return q3m;
    }
}
